import assertNever from 'assert-never';
import { BaseApi } from '@/main/baseApi';
import { DMS_MODULE as CISELNIK } from '@/modules/ciselnik/constants';
import { NAME as ZAKAZKALIST } from '@/modules/servis/zakazka/zakazkovyList/constants';

import { NAME as VOZIDLO } from '@/modules/kartoteka/vozidlo/constants';

import { DMS_MODULE as KARTOTEKA } from '@/modules/kartoteka/constants';


import {
	DependentTableNames,
	DMS_MODULE,
	DOKLAD_OSTATNI,
	ELSA_R,
	GDPR,
	PENDING_JOB_LIST,
	NAME,
	REF_TABLE,
	RESERVE_PARTS,
	SAGA_2_HLAV,
	SAGA_2_KOM,
	SAGA_2_POL,
	TAB_NAMES,
	VYDEJKA,
	VYDEJKAND,
	ZAKAZKA_CONTROL,
	ZAKAZKA_ND,
	ZAKAZKA_ND_PENDING,
	ZAKAZKA_PLAN_SKUT,
	ZAKAZKA_PNEU,
	ZAKAZKA_ZAPUJCKA,
	ZAK_ZALOHA,
	ODLOZENE_SERVISNI_CINNOSTI,
	CUSTOMER_FEEDBACK,
	OTEVRENE_ZAKAZKY,
	OZAKAZKA_ON_VOZIDLO,
	SERVICE_PKG_PARTS,
	SERVICE_PKG_LABOR,
	CAMPAIGN_DETAILS,
	ADVANCEPAY,
	POLOZKY,
	ATTACHMENT_FILES,
	NONGENUINE_ATTACHMENT_FILES,
	OrderReports,
	SERVICE_JOB_DETAILS,
	SERVICE_JOB_SPLIT_BILLING,
} from './constants';
import { NAME as ZAKAZKA_PRACOVNI_POZICE, ZAKAZKA_PP_PENDING } from './pracovniPozice/constants';
import { NAME as ZAKAZKA_CIZI_VYKONY } from './ciziVykony/constants';
import { NAME as ZAKAZKA_KOREKCE } from './korekce/constants';
import { NAME as DOKLAD } from '../doklad/constants';
import { NAME as JDNF } from '../jednotnaFrontaNd/constants';
import { OZAKAZKA } from '../constants';
import { NAME as SERVISNI_PAKET } from './servisniPakety/constants';

export const kryciDopisTiskUrl = `/${DMS_MODULE}/Reports/GetKryciDopisReport`;
export const customerCopyRepairOrderReportUrl = `/${DMS_MODULE}/Reports/Reports/GetCustomerCopyRepairOrderReport`;

type reportOptions = {
	[key: string]: string
};

const reportEnumToApi : reportOptions = {
	[OrderReports.CustomerCopyReport]: `/${DMS_MODULE}/Reports/GetCustomerCopyRepairOrderReport`,
	[OrderReports.DetailEstimateReport]: `/${DMS_MODULE}/Reports/DetailEstimateReport`,
	[OrderReports.QuickEstimateReport]: `/${DMS_MODULE}/Reports/QuickEstimateReport`,
	[OrderReports.ServiceInternalReport]: `/${DMS_MODULE}/Reports/GetServiceInternalReport`,
	[OrderReports.PickingListReport]: `/${DMS_MODULE}/Reports/GetReserveSPReport`,

	[OrderReports.CustomerSatisfactionVWReport]: '/Uctenky/Reports/GetCustomerSatisfactionReport',
	[OrderReports.CustomerSatisfactionSkodaReport]: '/Uctenky/Reports/GetCustomerSatisfactionReport',

	[OrderReports.WarrantyNoteReport]: '/Nd/Reports/GetWarrantyNoteReport',
	[OrderReports.WarrantyIssueSlipReport]: '/Nd/Reports/GetWarrantyIssueSlipReport',
	[OrderReports.PMSRequisitionSlip]: '/Nd/Reports/GetPMSRequestionSlipReport',
	[OrderReports.PMSIssueSlip]: '/Nd/Reports/GetPMSIssueSlipReport',

	[OrderReports.PartsSalesOrder]: `/${DMS_MODULE}/Reports/GetPartsSalesOrderReport`,
	[OrderReports.WorkShopCopy]: `/${DMS_MODULE}/Reports/GetWorkshopCopyReport`,
	[OrderReports.ServiceQuote]: `/${DMS_MODULE}/Reports/GetServiceQuoteReport`,
	[OrderReports.CourtesyCarAgreement]: `/${DMS_MODULE}/Reports/GetCourtesyCarAgreement`,
	[OrderReports.ServiceOrderConfirmationReport]: `/${DMS_MODULE}/Reports/GetServiceOrderConfirmationReport`,
	[OrderReports.ServiceOrderConfirmationDetailedReport]: `/${DMS_MODULE}/Reports/GetServiceOrderConfirmationReport?isDetailed=true`,
	[OrderReports.ServiceOrderConfirmationDetailedCustomerReport]: `/${DMS_MODULE}/Reports/GetServiceOrderConfirmationReport?isDetailed=true&IsPrimaryCustomer=true`,
	[OrderReports.VehicleReceptionChecklistReport]: `/${DMS_MODULE}/Reports/GetVehicleReceptionChecklistReport`,
	[OrderReports.ServiceOrderConfirmationReportV2]: `/${DMS_MODULE}/Reports/GetServiceOrderConfirmationReportV2?IsDetailed=true`,
	[OrderReports.ServiceOrderConfirmationDetailedReportV2]: `/${DMS_MODULE}/Reports/GetServiceOrderConfirmationDetailedReportV2?IsDetailed=true`,
	[OrderReports.ServiceQuoteV2]: `/${DMS_MODULE}/Reports/GetServiceQuoteV2`,
	[OrderReports.ServiceOrderConfirmationDetailedInternalReport]: `/${DMS_MODULE}/Reports/GetServiceOrderConfirmationDetailedReportV2
	?IsDetailed=true&IsInternalReport=true`,
};

class ZakazkaProvider extends BaseApi {
	schemaUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case ZAKAZKA_ND:
				return `/${this.area}/${ZAKAZKA_ND}/Schema`;
			case ZAKAZKA_ND_PENDING:
				return `/${this.area}/${ZAKAZKA_ND_PENDING}/Schema`;
			case ZAKAZKA_PP_PENDING:
				return `/${this.area}/${ZAKAZKA_PP_PENDING}/Schema`;
			case ZAKAZKA_CIZI_VYKONY:
				return `/${this.area}/${ZAKAZKA_CIZI_VYKONY}/Schema`;
			case ZAKAZKA_KOREKCE:
				return `/${this.area}/${ZAKAZKA_KOREKCE}/Schema`;
			case REF_TABLE:
				return `/${this.area}/${NAME}/RefSchema`;
			case VYDEJKA:
				return `/${this.area}/${VYDEJKA}/Schema`;
			case VYDEJKAND:
				return `/${this.area}/${VYDEJKA}/DilySchema`;
			case ZAKAZKA_PRACOVNI_POZICE:
				return `/${this.area}/${ZAKAZKA_PRACOVNI_POZICE}/Schema`;
			case ZAKAZKA_CONTROL:
				return `/${this.area}/${ZAKAZKA_CONTROL}/Schema`;
			case ZAKAZKA_ZAPUJCKA:
				return `/${this.area}/${ZAKAZKA_ZAPUJCKA}/Schema`;
			case ZAKAZKA_PNEU:
				return `/${this.area}/${ZAKAZKA_PNEU}/Schema`;
			case GDPR:
				return `/${this.area}/${NAME}/GdprSchema`;
			case PENDING_JOB_LIST:
				return `/${KARTOTEKA}/${VOZIDLO}/ZavadaSchema`;
			case SAGA_2_HLAV:
				return `/${this.area}/${NAME}/${SAGA_2_HLAV}Schema`;
			case SAGA_2_POL:
				return `/${this.area}/${NAME}/${SAGA_2_POL}Schema`;
			case SAGA_2_KOM:
				return `/${this.area}/${NAME}/${SAGA_2_KOM}Schema`;
			case ZAKAZKA_PLAN_SKUT:
				return `/${this.area}/${NAME}/${ZAKAZKA_PLAN_SKUT}/Schema`;
			case DOKLAD_OSTATNI:
				return `/${this.area}/${DOKLAD}/${DOKLAD_OSTATNI}Schema`;
			case ATTACHMENT_FILES:
				return `/${this.area}/${DOKLAD}/${ATTACHMENT_FILES}Schema`;
			case NONGENUINE_ATTACHMENT_FILES:
				return `/${this.area}/${DOKLAD}/${NONGENUINE_ATTACHMENT_FILES}Schema`;
			case ADVANCEPAY:
				return `/${this.area}/${DOKLAD}/${ADVANCEPAY}Schema`;
			case ZAK_ZALOHA:
				return `/${this.area}/${ZAK_ZALOHA}/Schema`;
			case ODLOZENE_SERVISNI_CINNOSTI:
				return `/${CISELNIK}/${ODLOZENE_SERVISNI_CINNOSTI}/Schema`;
			case CUSTOMER_FEEDBACK:
				return `/${this.area}/${NAME}/${CUSTOMER_FEEDBACK}Schema`;
			case OZAKAZKA_ON_VOZIDLO:
				return `/${this.area}/${OZAKAZKA}/Schema`;
			case OTEVRENE_ZAKAZKY:
				return `/${this.area}/${OTEVRENE_ZAKAZKY}/Schema`;
			case SERVICE_PKG_PARTS:
				return `/${this.area}/${SERVICE_PKG_PARTS}/Schema`;
			case SERVICE_PKG_LABOR:
				return `/${this.area}/${SERVICE_PKG_LABOR}/Schema`;
			case CAMPAIGN_DETAILS:
				return `/${this.area}/${CAMPAIGN_DETAILS}/Schema`;
			case POLOZKY:
				return `/${this.area}/${NAME}/${POLOZKY}Schema`;
			case RESERVE_PARTS:
				return `/${this.area}/${VYDEJKA}/ReservePartsSchema`;
			case SERVICE_JOB_DETAILS:
				return `/${this.area}/${SERVICE_JOB_DETAILS}/Schema`;
			default:
				return assertNever(tableName);
		}
	}

	tableUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case ZAKAZKA_ND:
				return `/${this.area}/${ZAKAZKA_ND}/`;
			case ZAKAZKA_ND_PENDING:
				return `/${this.area}/${ZAKAZKA_ND_PENDING}/`;
			case ZAKAZKA_CIZI_VYKONY:
				return `/${this.area}/${ZAKAZKA_CIZI_VYKONY}/`;
			case ZAKAZKA_KOREKCE:
				return `/${this.area}/${ZAKAZKA_KOREKCE}/`;
			case REF_TABLE:
				return `/${this.area}/${NAME}/RefRows`;
			case VYDEJKA:
				return `/${this.area}/${VYDEJKA}`;
			case VYDEJKAND:
				return `/${this.area}/${VYDEJKA}/DilyRows`;
			case ZAKAZKA_PRACOVNI_POZICE:
				return `/${this.area}/${ZAKAZKA_PRACOVNI_POZICE}/`;
			case ZAKAZKA_PP_PENDING:
				return `/${this.area}/${ZAKAZKA_PP_PENDING}/`;
			case ZAKAZKA_CONTROL:
				return `/${this.area}/${ZAKAZKA_CONTROL}`;
			case ZAKAZKA_ZAPUJCKA:
				return `/${this.area}/${ZAKAZKA_ZAPUJCKA}`;
			case ZAKAZKA_PNEU:
				return `/${this.area}/${ZAKAZKA_PNEU}`;
			case GDPR:
				return `/${this.area}/${NAME}/GdprRows`;
			case PENDING_JOB_LIST:
				return `/${KARTOTEKA}/${VOZIDLO}/ZavadaRows`;
			case SAGA_2_HLAV:
				return `/${this.area}/${NAME}/${SAGA_2_HLAV}Rows`;
			case SAGA_2_POL:
				return `/${this.area}/${NAME}/${SAGA_2_POL}Rows`;
			case SAGA_2_KOM:
				return `/${this.area}/${NAME}/${SAGA_2_KOM}Rows`;
			case ZAKAZKA_PLAN_SKUT:
				return `/${this.area}/${NAME}/${ZAKAZKA_PLAN_SKUT}/Rows`;
			case DOKLAD_OSTATNI:
				return `/${this.area}/${DOKLAD}/${DOKLAD_OSTATNI}Rows`;
			case ATTACHMENT_FILES:
				return `/${this.area}/${DOKLAD}/${ATTACHMENT_FILES}Rows`;
			case NONGENUINE_ATTACHMENT_FILES:
				return `/${this.area}/${DOKLAD}/${NONGENUINE_ATTACHMENT_FILES}Rows`;
			case ADVANCEPAY:
				return `/${this.area}/${DOKLAD}/${ADVANCEPAY}Rows`;
			case ODLOZENE_SERVISNI_CINNOSTI:
				return `/${CISELNIK}/${ODLOZENE_SERVISNI_CINNOSTI}/`;
			case CUSTOMER_FEEDBACK:
				return `/${this.area}/${NAME}/${CUSTOMER_FEEDBACK}Rows`;
			case ZAK_ZALOHA:
				return `/${this.area}/${ZAK_ZALOHA}`;
			case OZAKAZKA_ON_VOZIDLO:
				return `/${this.area}/${OZAKAZKA}/${OZAKAZKA_ON_VOZIDLO}`;
			case OTEVRENE_ZAKAZKY:
				return `/${this.area}/${OTEVRENE_ZAKAZKY}`;
			case SERVICE_PKG_PARTS:
				return `/${this.area}/${SERVICE_PKG_PARTS}`;
			case SERVICE_PKG_LABOR:
				return `/${this.area}/${SERVICE_PKG_LABOR}`;
			case CAMPAIGN_DETAILS:
				return `/${this.area}/${CAMPAIGN_DETAILS}`;
			case POLOZKY:
				return `/${this.area}/${NAME}/${POLOZKY}Rows`;
			case RESERVE_PARTS:
				return `/${this.area}/${VYDEJKA}/ReservePartsRows`;
			case SERVICE_JOB_DETAILS:
				return `/${this.area}/${SERVICE_JOB_DETAILS}`;
			default:
				return assertNever(tableName);
		}
	}

	tableDeleteEntityUrl(tableName: string) {
		switch (tableName) {
			case ZAKAZKA_ND:
				return `/${this.area}/${ZAKAZKA_ND}/`;
			case ZAKAZKA_ND_PENDING:
				return `/${this.area}/${ZAKAZKA_ND_PENDING}/`;
			case ZAKAZKA_PP_PENDING:
				return `/${this.area}/${ZAKAZKA_PP_PENDING}/`;
			case ZAKAZKA_PRACOVNI_POZICE:
				return `/${this.area}/${ZAKAZKA_PRACOVNI_POZICE}/`;
			case ZAKAZKA_KOREKCE:
				return `/${this.area}/${ZAKAZKA_KOREKCE}/`;
			case ZAKAZKA_CIZI_VYKONY:
				return `/${this.area}/${ZAKAZKA_CIZI_VYKONY}/`;
			case ZAKAZKA_ZAPUJCKA:
				return `/${this.area}/${ZAKAZKA_ZAPUJCKA}/`;
			case ZAKAZKA_PNEU:
				return `/${this.area}/${ZAKAZKA_PNEU}/`;
			case ODLOZENE_SERVISNI_CINNOSTI:
				return `/${CISELNIK}/${ODLOZENE_SERVISNI_CINNOSTI}/`;
			case CUSTOMER_FEEDBACK:
				return `/${this.area}/${NAME}/${CUSTOMER_FEEDBACK}/Schema`;
			case ZAK_ZALOHA:
				return `/${this.area}/${ZAK_ZALOHA}/`;
			default:
				return `/${this.area}/${this.controller}/${tableName}DeleteEntity`;
		}
	}

	async zakaznickaSkupinaChange(zakazka: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/ZmenaZakaznickaSkupina`, zakazka);
	}

	async fakturacniProfilChange(zakazka: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/ZmenaFakturaceProfil`, zakazka);
	}

	async vozidloChange(zakazka: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/ZmenaVozidlo`, zakazka);
	}

	async zakaznikChange(zakazka: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/ZmenaZakaznik`, zakazka);
	}

	async getPodily(zakazkaId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetFaktPodily?zakazkaId=${zakazkaId}`);
	}

	async sendNotificationForAdditionalAmount(orderNotificationInputDTO: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/SendNotificationForAdditionalAmount`, orderNotificationInputDTO);
	}

	async sendNotificationForSafetyRemark(zakazkaId: number) {
		return this.post(`/${DMS_MODULE}/${NAME}/SendNotificationForSafetyRemark?zakazkaId=${zakazkaId}`);
	}

	async intPodilChange(zakazka: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/ZmenaPodilInt`, zakazka);
	}

	async approveAdditionalAmount(orderId: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/ApproveAdditionalAmount?orderId=${orderId}`);
	}

	async zakPodilChange(zakazka: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/ZmenaPodilZak`, zakazka);
	}

	async provozovnaChange(zakazka: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/ZmenaProvozovna`, zakazka);
	}

	async pojistovnaChange(zakazka: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/ZmenaPojistovna`, zakazka);
	}

	async leasingChange(zakazka: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/ZmenaLeasing`, zakazka);
	}

	async jinyPrijemceChange(zakazka: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/ZmenaJinyPrijemce`, zakazka);
	}

	async smluvniPartnerChange(zakazka: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/ZmenaSmluvniPartner`, zakazka);
	}

	async smluvniPartnerTypChange(zakazka: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/ZmenaSmluvniPartnerTyp`, zakazka);
	}

	// Interni zakazka
	async interniZakaznickaSkupinaChange(zakazka: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/ZmenaZakaznickaSkupinaInterni`, zakazka);
	}

	async interniFakturacniProfilChange(zakazka: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/ZmenaFakturaceProfilInterni`, zakazka);
	}

	async interniDruhChange(zakazka: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/ZmenaInterniDruh`, zakazka);
	}

	async getVozidlo(zakazkaId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/Vozidlo`, { zakazkaId });
	}

	async slevaChange(zakazka: any) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/SlevaChange`, zakazka);
		// TODO/TP1: upravit podle BE endpointu
	}

	async getDMZ(zakazkaId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetUrlForDzm`, { zakazkaId });
	}

	async getPocetOtevrenychZakazek(vozidloId: number | null) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/PocetOtevrenychZakazek?vozidloId=${vozidloId}`);
	}

	async mergeWithOzakazka(filter: any) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/PropojSOZakazkou`, filter);
	}

	async zmenaPnv(zakazka: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/ZmenaPnv`, zakazka);
	}

	async zmenaPov(zakazka: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/ZmenaPov`, zakazka);
	}

	async zmenaNVozidlo(zakazka: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/ZmenaNVozidlo`, zakazka);
	}

	async zmenaOvozidlo(zakazka: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/ZmenaOvozidlo`, zakazka);
	}

	async zmenaNvSklad(zakazka: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/ZmenaNvSklad`, zakazka);
	}

	attachmentFilesSchemaAndRows(filter: any) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/AttachmentFilesSchemaAndRows`, filter);
	}

	certSpecOprReport(filter: {}) {
		return this.fetchPdf('/Reports/Reports/GetCertSpecOprReport', filter);
	}

	getPneuPredavaciProtokolServisReport(filter: {}) {
		return this.fetchPdf(`/${DMS_MODULE}/Reports/GetPneuPredavaciProtokolServisReport`, filter);
	}

	generateGatePass(zakazkaId: number | null) {
		return this.fetchPdf(`/${DMS_MODULE}/${NAME}/PrintGatePass?orderId=${zakazkaId}`);
	}

	specialistaOpravReport(filter: {}) {
		return this.fetchPdf(`/${DMS_MODULE}/Reports/GetSpecialistaOpravReport`, filter);
	}

	upravaPolozkyCheck(filter: {}) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/Saga2UpravaPolozky`, filter);
	}

	async checkGatePass(orderId: number) {
		const result = await this.fetch(`/${DMS_MODULE}/${NAME}/CheckGatePass?orderId=${orderId}`);
		return (result instanceof Error) ? { Result: false } : result.data;
	}

	isKalkulaceSentToRemote(params: { zakazkaId: number, kalkulacePzn: number }) {
		return this.fetch(`/${DMS_MODULE}/${TAB_NAMES.KALKULACE}/IsKalkulaceSentToRemote`, params);
	}

	getKalkulaceFromRemote(params: { zakazkaId: number, kalkulacePzn: number }) {
		return this.fetch(`/${DMS_MODULE}/${TAB_NAMES.KALKULACE}/GetKalkulaceFromRemote`, params);
	}

	getKalkulaceRtfAsHtml(params: { zakazkaId: number }) {
		return this.fetch(`/${DMS_MODULE}/${TAB_NAMES.KALKULACE}/GetKalkulaceRtfAsHtml`, params);
	}

	getFindKalkulaceInRemoteSchemaAndRows(params: { zakazkaId: number, kalkulacePzn: number }) {
		return this.fetch(`/${DMS_MODULE}/${TAB_NAMES.KALKULACE}/GetFindKalkulaceInRemoteSchemaAndRows`, params);
	}

	addKalkulace(params: { zakazkaId: number, kalkulacePzn: number, anotherId: string }) {
		return this.post(`/${DMS_MODULE}/${TAB_NAMES.KALKULACE}/AddKalkulace`, params);
	}

	takeNdToKalkulace(params: { zakazkaId: number, pracovnikId: number }) {
		return this.post(`/${DMS_MODULE}/${TAB_NAMES.KALKULACE}/TakeNdToKalkulace`, params);
	}

	takePpToKalkulace(params: { zakazkaId: number, pracovnikId: number, provozovnaId: number, stredNaklOzn: number, lakDruhId: number }) {
		return this.post(`/${DMS_MODULE}/${TAB_NAMES.KALKULACE}/TakePpToKalkulace`, params);
	}

	deleteKalkulace(params: { zakazkaId: number }) {
		return this.fetch(`/${DMS_MODULE}/${TAB_NAMES.KALKULACE}/DeleteKalkulace`, params);
	}

	sendKalkulace(params: { ZakazkaId: number, KalkulacePzn: number }) {
		return this.post(`/${DMS_MODULE}/${TAB_NAMES.KALKULACE}/SendKalkulaceToRemote`, params);
	}

	getTaskUrlForOpen(params: { ZakazkaId: number, KalkulacePzn: number }) {
		return this.post(`/${DMS_MODULE}/${TAB_NAMES.KALKULACE}/GetTaskUrlForOpen`, params);
	}

	klonZakazky(params: {}) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/KlonZakazky`, params);
	}

	zakazkaDefault(ZakazkaData: object) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/Default`, ZakazkaData);
	}

	zakazkaSave(ZakazkaData: object) {
		return this.post(`/${DMS_MODULE}/${NAME}`, ZakazkaData);
	}

	prevedNabidkuDoPripravy(zakazka: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/PrevedNabidkuDoPripravy`, zakazka);
	}

	prevodNaOtevrenou(zakazka: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/PrevedPripravenouNaOtevrenou`, zakazka);
	}

	uvolnenaToOtevrena(zakazka: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/PrevedUvolnenouNaOtevrenou`, zakazka);
	}

	changeToKulance(zakazka: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/ChangeToKulance`, zakazka);
	}

	changeToGarance(zakazka: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/ChangeToGarance`, zakazka);
	}

	changeToInterni(zakazka: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/ChangeToInterni`, zakazka);
	}

	getZakazkaByNr(zakazkaNr: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/getZakazkaByNr`, { zakazkaNr });
	}

	workshopInfoViews(zakazkaId: number) {
		return this.fetch(`/${ELSA_R}/WorkshopInfoViews`, { zakazkaId });
	}

	getIsCarInfoEnabled(vozidloId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetIsCarInfoEnabled`, { vozidloId });
	}

	getCarDescriptionAsDto(zakazkaId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetCarDescriptionAsDto`, { zakazkaId });
	}

	getPrice(zakazkaId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/CenaCelkem`, { zakazkaId });
	}

	isSplittedOrder(zakazkaId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/IsSplittedOrder`, { zakazkaId });
	}

	getJdnfCount(zakazkaId: number) {
		return this.fetch(`/${DMS_MODULE}/${JDNF}/Count`, { zakazkaId });
	}

	getPaketyCount(zakazkaId: number) {
		return this.fetch(`/${DMS_MODULE}/${SERVISNI_PAKET}/Count`, { zakazkaId });
	}

	saveAdvancePay(zakazka: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/SaveAdvancePay`, zakazka);
	}

	sendAdvancePaymentNotification(orderId: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/SendNotificationForAdvancePayment?orderId=${orderId}`);
	}

	printAdvancePayReceipt(zakazkaId: number, advancePayId: number) {
		return this.fetchPdf(`/${DMS_MODULE}/${NAME}/PrintAdvancePayReceipt?zakazkaId=${zakazkaId}&advancePayId=${advancePayId}`);
	}

	cancelOrder(zakazka: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/CancelOrder`, zakazka);
	}

	async getKMStavs(zakazkaId: number) {
		const result = await this.fetch(`/${DMS_MODULE}/${NAME}/GetKMStavs`, { zakazkaId });
		return (result instanceof Error) ? { Result: false } : result.data;
	}

	async isProformaCreated(zakazkaId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/IsProformaCreated`, { zakazkaId });
	}

	customerFirstVisitCheck(vozidloId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/CheckCustomerFirstVisit`, { vozidloId });
	}

	getCampaignDetails(vozidloVin: string, zakazkaId: number | null, oZakazkaId: number | null = null) {
		return this.fetch(`/${DMS_MODULE}/Campaign`, { vozidloVin, zakazkaId, oZakazkaId });
	}

	getSourceType() {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetSourceType`);
	}

	getRemarkType() {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetRemarkType`);
	}

	createLabor(zakazkaId: number, ServicePackageId: number, VehicleId: number) {
		return this.fetch(`/${DMS_MODULE}/ZakazkaPracovniPozice/CreateLabor`, { zakazkaId, ServicePackageId, VehicleId });
	}

	async manageLaborOperations(laborOperations: Object) {
		return this.post(`/${DMS_MODULE}/ZakazkaPracovniPozice/ManageLaborOperations`, laborOperations);
	}

	async managePartsOperations(partsOperations: Object) {
		return this.post(`/${DMS_MODULE}/ZakazkaNd/ManagePartsOperations`, partsOperations);
	}

	async manageExtLaborOperations(extLaborOperations: Object) {
		return this.post(`/${DMS_MODULE}/ZakazkaCiziVykony/ManageExtLaborOperations`, extLaborOperations);
	}

	async manageServiceJobOperations(serviceJobOperations: Object) {
		return this.post(`/${DMS_MODULE}/ServiceJobDetails/ManageServiceJobOperations`, serviceJobOperations);
	}

	createParts(zakazkaId: number, servicePackageId: number, vehicleId: Number) {
		return this.fetch(`/${DMS_MODULE}/ZakazkaRezervaceNd/InsertServicePkgParts`, { zakazkaId, servicePackageId });
	}

	validateServicePackagePartsInInventory(ServicePackageId: number, VehicleId: Number) {
		return this.fetch(`/${DMS_MODULE}/ZakazkaNd/ValidateServicePackagePartsInInventory`, { ServicePackageId, VehicleId });
	}

	ValidateGrossDiscountAmountForIssuedPartSplitParties(
		serviceOrderId: number,
		itemId: number,
		itemType: string,
		lineLevelDiscountAmount: number,
		lineLevelDiscountLimitPercent: number | null,
		serviceJobId: number | null,
		rrpUnitPrice: number,
		brandDiscount: number | null = null,
		billTo: number | null = null,
	) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/ValidateGrossDiscountAmountForIssuedPartSplitParties`, {
			serviceOrderId,
			itemId,
			itemType,
			lineLevelDiscountAmount,
			lineLevelDiscountLimitPercent,
			serviceJobId,
			rrpUnitPrice,
			brandDiscount,
			billTo,
		});
	}

	validateGrossDiscountAmountForSplitParties(
		serviceOrderId: number,
		itemId: number,
		itemType: string,
		lineLevelDiscountAmount: number,
		lineLevelDiscountLimitPercent: number | null,
		rrpUnitPrice: number,
		quantity: number,
	) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/ValidateGrossDiscountAmountForSplitParties`, {
			serviceOrderId,
			itemId,
			itemType,
			lineLevelDiscountAmount,
			lineLevelDiscountLimitPercent,
			rrpUnitPrice,
			quantity,
		});
	}

	getOrderSubType(brand: string) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetOrderSubType`, { brand });
	}

	deletePackageLabor(zakazkaId: number) {
		return this.fetch(`/${DMS_MODULE}/ZakazkaPracovniPozice/DeleteServicepackageLabor`, { zakazkaId });
	}

	deletePackageParts(zakazkaId: number) {
		return this.fetch(`/${DMS_MODULE}/ZakazkaNd/DeleteServicePkgParts`, { zakazkaId });
	}

	deletePackageReserveParts(zakazkaId: number) {
		return this.fetch(`/${DMS_MODULE}/ZakazkaRezervaceNd/DeleteServicePkgParts`, { zakazkaId });
	}

	getWorkCompletionStatus(params: { zakazkaId: number }) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetWorkCompletionStatus`, params);
	}

	sendWorkNotification(params: { zakaznikId: number | null, zakazkaNr: number | null }) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/SendWorkNotification`, params);
	}

	getGatePassServisReport(filter: {}) {
		return this.fetchPdf(`/${DMS_MODULE}/Reports/GetGatePass`, filter);
	}

	cancelOrRescheduleOrder(zakazkaId: number, OzakazkaId: number, comments: string) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/CancelOrder`, { zakazkaId, OzakazkaId, comments });
	}

	rescheduleOrder(zakazkaId: number, OzakazkaId: number, comments: string, pDate: string) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/RescheduleOrder`, { zakazkaId, OzakazkaId, comments, pDate });
	}

	test() {
		return this.postPdf('Uctenky/Servis/TvorbaFakturyTest?nahled=false');
	}

	saveDocument(fileList: any, zakazkaId: null | number) {
		const file = new FormData();
		file.append('file', fileList.raw, fileList.name);
		return this.uploadMultipart(`/${DMS_MODULE}/${NAME}/SaveDocument?ZakaznikId=${zakazkaId}`, file);
	}

	nonGenuineSaveDocument(fileList: any, vozidloId: null | number, isTotalLoss: null | boolean) {
		const file = new FormData();
		file.append('file', fileList.raw, fileList.name);
		return this.uploadMultipart(`/${DMS_MODULE}/${NAME}/NonGenuineSaveDocument?vozidloId=${vozidloId}&isTotalLoss=${isTotalLoss}`, file);
	}

	getDocuments(fileId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GettachamentFilestDocument?fileId=${fileId}`);
	}

	getNonGenuineDocuments(fileId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GettNonGenuineachamentFilestDocument?fileId=${fileId}`);
	}

	deleteAttachamentDocuments(fileId: number) {
		return this.post(`/${DMS_MODULE}/${NAME}/DeleteAttachamentDocuments?fileId=${fileId}`);
	}

	deleteNonGenuineAttachamentDocuments(fileId: number) {
		return this.post(`/${DMS_MODULE}/${NAME}/DeleteNonGenuineAttachamentDocuments?fileId=${fileId}`);
	}

	async getRepeatRepairRevisit(Vozidloidi: number, odometer: number) {
		return this.fetch(`/${DMS_MODULE}/VozidloCheckIn/GetRepeatRepairRevisit?VehicleId=${Vozidloidi}&odom=${odometer}`);
	}

	async orderSubTypeCheck(VozidloId: number, OrderSubtypeId: number, ZakazkaId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/OrderSubTypeCheck?VozidloId=${VozidloId}&OrderSubtypeId=${OrderSubtypeId}&ZakazkaId=${ZakazkaId}`);
	}

	async updatePartDiscount(zakazkaId: number, discountPercentage: number | null, discountValue: number | null) {
		const result = await this.fetch(`/${DMS_MODULE}/${NAME}/UpdatePartDiscount`, { zakazkaId, discountPercentage, discountValue });
		return (result instanceof Error) ? { Result: false } : result.data;
	}

	async updateLabourDiscount(zakazkaId: number, discountPercentage: number | null, discountValue: number | null) {
		const result = await this.fetch(`/${DMS_MODULE}/${NAME}/UpdateLabourDiscount`, { zakazkaId, discountPercentage, discountValue });
		return (result instanceof Error) ? { Result: false } : result.data;
	}

	async updateDiscount(zakazkaId: number, discountPercentage: number | null, discountValue: number | null) {
		const result = await this.fetch(`/${DMS_MODULE}/${NAME}/UpdateDiscount`, { zakazkaId, discountPercentage, discountValue });
		return (result instanceof Error) ? { Result: false } : result.data;
	}

	async eGUIIssueInvoiceAdvancePayment(eGUIIssueInvoiceRequestDTO: object, advancePayment: number | null) {
		return this.post(`/Uctenky/Servis/EGUI_IssueInvoice_AdvancePayment?advancePayment=${advancePayment}`, eGUIIssueInvoiceRequestDTO);
	}

	async eGUIPrintInvoice(eGUIPrintInvoiceRequestDTO: {}) {
		return this.fetch('/Uctenky/Servis/EGUI_PrintInvoice', eGUIPrintInvoiceRequestDTO);
	}

	async eGUICancelAdvancePaymentInvoice(eGUICancelInvoiceRequestDTO: {}, advancePaymentId: number | null) {
		return this.fetch(`/Uctenky/Servis/EGUI_Cancel_AdvancePayment_Invoice?advancepaymentId=${advancePaymentId}`, eGUICancelInvoiceRequestDTO);
	}

	async eGUIPrintAdvancePaymentInvoice(eGUIPrintInvoiceRequestDTO: {}, advancePaymentId: any) {
		return this.fetch(`/Uctenky/Servis/EGUI_Print_AdvancePayment_Invoice?advancePaymentId=${advancePaymentId}`, eGUIPrintInvoiceRequestDTO);
	}

	async isEGUICreated(orderId: number | null, advancePaymentId: number | null) {
		return this.fetch(`/Uctenky/Servis/Is_EGUI_Created?orderId=${orderId}&advancePaymentId=${advancePaymentId}`);
	}

	async cancelAdvancePayment(orderId: number | null, advancePaymentId: number | null) {
		return this.fetch(`/Uctenky/Servis/CancelAdvancePayment?orderId=${orderId}&advancePaymentId=${advancePaymentId}`);
	}

	async eGUICancelInvoice(eGUICancelInvoiceRequestDTO: {}) {
		const result = await this.fetch(`/${DMS_MODULE}/${NAME}/EGUI_CancelInvoice`, eGUICancelInvoiceRequestDTO);
		return (result instanceof Error) ? { Result: false } : result.data;
	}

	async getCustomerIdentifier(zakaznikId :number | null) {
		return this.fetch(`/Servis/Zakazka/GetCustomerIdentifier?customerId=${zakaznikId}`);
	}

	async archiveParts(ZakazkaId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/ArchiveParts?ZakazkaId=${ZakazkaId}`);
	}

	async discardOrder(zakazkaId: number, cancelRemarks: string | null, cancelType: number | null) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/DiscardOrder?zakazkaId=${zakazkaId}&cancelRemarks=${cancelRemarks}&cancelType=${cancelType}`);
	}

	async saveDeliveryStartTime(orderId: number) {
		return this.post(`/${DMS_MODULE}/${NAME}/SavedeliveryStartTime?orderId=${orderId}`);
	}

	async getSADetails(ZakazkaId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetSADetails?ZakazkaId=${ZakazkaId}`);
	}

	markReportAsPrinted(zakazkaId: number, reportType: string) {
		return this.post(`/Servis/Zakazka/MarkAsPrint?id=${zakazkaId}&reportType=${reportType}`);
	}

	async isTotalLoss(VozidloId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/IsTotalLoss?vozidloId=${VozidloId}`);
	}


	async isNonGenuine(VozidloId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/IsNonGenuine?vozidloId=${VozidloId}`);
	}


	async updateCampaignDiscount(VozidloId: number, OrderSubtypeId: number, ZakazkaId: number, VozidloVin: string) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/UpdateCampaignDiscount?VozidloId=${VozidloId}&OrderSubtypeId=${OrderSubtypeId}&ZakazkaId=${ZakazkaId}&VozidloVin=${VozidloVin}`);
	}


	async getTotalLossDetails(VozidloId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetTotalLossDetails?vozidloId=${VozidloId}`);
	}

	async GetNonGenuineDetails(VozidloId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetNonGenuineDetails?vozidloId=${VozidloId}`);
	}

	async getReport(filter: object, ReportID: string) {
		return this.fetchPdf(`${reportEnumToApi[ReportID]}`, filter);
	}

	async isWatchlistedVIN(VozidloVin: string) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/Iswatchlistedcar?VozidloVin=${VozidloVin}`);
	}

	async sendWatchlistedEmail(zakazka: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/SendWatchlistedEmail`, zakazka);
	}

	async IsVasAndWashingLaborComplete(ZakazkaId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/IsVasAndWashingLaborComplete?orderId=${ZakazkaId}`);
	}

	async IsLaborOperationStarted(zakazkaId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/IsLaborOperationStarted?zakazkaId=${zakazkaId}`);
	}


	async createAudatex(zakazka: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/AudatexCreatTask`, zakazka);
	}

	async audatexCreatTask(zakazka: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/AudatexCreatTask`, zakazka);
	}

	async audatexGetTask(zakazkaId: number, taskId: string) {
		return this.post(`/${DMS_MODULE}/${NAME}/AudatexGetTask?zakazkaId=${zakazkaId}&taskId=${taskId}`);
	}

	async getEachPartyStatusMappedToLineItems(serviceOrderId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetEachPartyStatusMappedToLineItems?serviceOrderId=${serviceOrderId}`);
	}

	async saveOrUpdateCampaign(zakazkaId: number | null, campaignId: number | null, oZakazkaId: number | null = 0) {
		return this.update(`/${DMS_MODULE}/Campaign/UpdateOrderCampaign?orderId=${zakazkaId}&campaignId=${campaignId}&plannedOrderId=${oZakazkaId}`, null, true);
	}

	async getTargetWarehouseByWorkshopId(workshopId: any) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetTargetWarehouseByWorkshopId?workshopId=${workshopId}`);
	}

	async GetTargetWarehouseByWorkshopAndWarehouseId(workshopId: any, warehouseId: any) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetTargetWarehouseByWorkshopAndWarehouseId?workshopId=${workshopId}&warehouseId=${warehouseId}`);
	}

	async getWarehouseByWorkshopId(workshopId: any) {
		return this.fetch(`/Servis/Zakazka/GetWarehouse?workshopId=${workshopId}`);
	}

	async isSagaSplitsExistInServiceJobSplit(serviceJobId:number, serviceOrderId:number) {
		return this.fetch(`/${DMS_MODULE}/${SERVICE_JOB_SPLIT_BILLING}/IsSagaSplitExistsInServiceJob`, { serviceOrderId, serviceJobId });
	}

	async getSplitDetails(itemId: number | null, orderId: number | null) {
		return this.fetch(`/${DMS_MODULE}/SplitBilling/GetSplitTooltip`, { itemId, orderId });
	}

	async canReturnPart(partId: number[], orderId: number | null) {
		return this.fetch(`/${DMS_MODULE}/SplitBilling/CanReturnPart`, { partId, orderId });
	}

	async canRevertLabours(labourIds: number[]) {
		return this.fetch(`/${DMS_MODULE}/SplitBilling/CanRevertLabours`, { labourIds });
	}

	async eGUICheckBarcode(eGUICheckBarcodeRequestDTO: {}) {
		return this.fetch('/Uctenky/Servis/EGUI_CheckBarcode', eGUICheckBarcodeRequestDTO);
	}

	async AssignWorkshopOrder(orderId: number | null) {
		return this.post(`Servis/Zakazka/AssignWorkshopOrder?orderId=${orderId}`);
	}

	async GetWorkshopOrder(orderId: number | null) {
		return this.post(`Servis/Zakazka/GetWorkshopOrder?orderId=${orderId}`);
	}

	async isAllPartiesCreditNoteApproved(laborIds: number[], orderId:number) {
		return this.fetch(`/${DMS_MODULE}/SplitBilling/IsAllPartiesCreditNoteApproved`, { laborIds, orderId });
	}

	async getPartsList(brand: string, orderId: number) {
		return this.fetch(`/Servis/Ozakazka/GetPartsList?OrderId=${orderId}&HledejPodretezecNdNr=true&VyrobekndOzn=${brand}`);
	}

	async isAnySplitPartyInoviced(orderId:number | null, itemId:number | null, itemType:string) {
		return this.fetch(`/${DMS_MODULE}/Zakazka/IsAnySplitPartyInoviced`, { orderId, itemId, itemType });
	}

	getCustomerByGoldenAccountId(customerId: number | null, vin: string | null, refreshflag: number | null) {
		return this.fetch(`Kartoteka/Partner/getCustomerByGoldenAccountId?customerId=${customerId}&vin=${vin}&refreshflag=${refreshflag}`);
	}

	async CheckDnpValue(OrderId: number) {
		return this.fetch('/Servis/ZakazkaNd/CheckDnpValue', { OrderId });
	}

	AssignWorkshopOrders(orderId: number | null) {
		return this.post(`/${DMS_MODULE}/${NAME}/AssignWorkshopOrder?orderId=${orderId}`);
	}

	assignLaborOperations(orderId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/AssignLaborOperations?orderId=${orderId}`);
	}

	autoAssignCancelled(orderId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/AutoAssignCancelled?orderId=${orderId}`);
	}

	async isLineItemPresent(orderId: number, vehicleId: number | null, customerId: number | null) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/IsLineItemPresent`, { orderId, vehicleId, customerId });
	}

	async isLaborInProgress(orderId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/IsLaborInProgress`, { orderId });
	}

	async isCustomerTyperInternal(customerId: number | null) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/IsCustomerTypeInternal`, { customerId });
	}

	async isDuplicateOrder(vehicleId: number | null) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/IsDuplicateOrder`, { vehicleId });
	}
	async getReleaseOrderData(orderId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetReleaseOrderData?orderId=${orderId}`);
	}
	async navigateToBillingScreen(orderId: number, isBillingScreen: boolean) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/NavigateToBillingScreen?orderId=${orderId}&isBillingScreen=${isBillingScreen}`);
	}
	async getCombinedSchemas(tableNames: string[]) {
		return this.post(`/${DMS_MODULE}/${NAME}/GetCombinedSchemas`, { tableNames });
	}
	async getCombinedData(orderId: number, zakaznikId: number, brand: string, pujcovnapaId: number) {
		const filter = { filter: { ZakazkaId: orderId, ZakaznikId: zakaznikId, VyrobekndOzn: brand, PujcovnapaId: pujcovnapaId } };
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetCombinedData`, filter);
	}
	async getCustomerContactDetails(vehicleId: number, customerId: number) {
		return this.fetch(`Kartoteka/Partner/GetCustomerContactDetails?vehicleId=${vehicleId}&customerId=${customerId}`)
	}
	async saveCustomerContactDetails(customerInputDTO: object) {
		return this.post(`Kartoteka/Partner/InsertCustomerContact`, customerInputDTO)
	}

	async GetOrderContactDetails(orderId: number, isServiceOrder: boolean) {
		return this.fetch(`Kartoteka/Partner/GetOrderContactDetails?orderId=${orderId}&isServiceOrder=${isServiceOrder}`);
	}
}

export const apiProvider = new ZakazkaProvider(DMS_MODULE, NAME);
